import { Injectable } from '@angular/core';
import { CrudService } from '../../services';
import { Invoice } from '../../dto/invoice';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from '../../../../node_modules/rxjs';
import { DataListModel } from '../../models/data-list-model';
import {Payment} from '../../dto/payment';
import {DateTableFilter} from '../../table-datasouces/date-table-filter';
import {PrevNextModel} from '../../models/prev-next-model';
import {toISODateString, toServerDateString} from '../../providers/app-date-adapter';
import {AnnualFeeStatsModel} from '../../models/annual-fee-stats-model';
import {AnnualFeeStatsFilteringModel} from '../../models/annual-fee-stats-filtering-model';
import {DebtorServiceLogEntity} from '../../dto/debtor-service-log-entity';
import {Upload} from "../../dto/upload";
import {getLocalISOString} from "../../helpers/date-tostring-helper";

@Injectable({
  providedIn: 'root'
})
export class InvoicesService implements CrudService<Invoice> {

  readonly apiPath = 'invoices/';

  constructor(private http: HttpClient) { }
  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<Invoice>;
  }
  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string) {
    const params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set( 'sortDirection', sortDirection )
      .set( 'someAdditionalData', someAdditionalData );
    return this.http.get(this.apiPath, { params }) as Observable<DataListModel<Invoice>>;
  }

  getAttachment( invoiceId: number ): Observable<HttpResponse<Blob>> {
    return this.http.get( this.apiPath + invoiceId + '/attachment', { params: null, responseType: 'blob', observe: 'response' } );
  }

  getByCustomerId( customerId: number, includeArchived: boolean ): Observable<Invoice[]> {

    let params = new HttpParams()
      .set('includeArchived', includeArchived)

    return this.http.get(this.apiPath+'by-customer-id/'+customerId, { params }) as Observable<Invoice[]>;
  }



  add(item: Invoice): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  update(item: Invoice) {
    return this.http.put(this.apiPath, item) as Observable<Invoice>;
  }

  delete(id: any) {
    return this.deleteMany([id]);
  }
  restore(id: any) {
    return this.restoreMany([id]);
  }

  deleteMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }

  restoreMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath, null, { params: httpParams });
  }

  markAsPaidMany( idList: any[] ): Observable<Object> {
    let httpParams = new HttpParams();

    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );

    return this.http.patch( this.apiPath + 'mark-as-paid', null, { params: httpParams } );
  }

  getPayments(invoiceId: any) {
    return this.http.get(this.apiPath + 'get-payments/'+invoiceId) as Observable<Payment[]>;
  }

  getDebtorServiceErrorLogs(invoiceId: number) {
    return this.http.get(this.apiPath + 'debtor-service-log-errors/'+invoiceId) as Observable<DebtorServiceLogEntity[]>;
  }

  addPayment( item: Payment ) {
    return this.http.post(this.apiPath+'add-payment', item) as Observable<Payment>;
  }

  resetSentAttempts( invoiceId ) {
    return this.http.post(this.apiPath+'reset-sent-attemts/'+invoiceId, {}) as Observable<number>;
  }

  deletePayment( paymentId: number ) {
    return this.http.delete(this.apiPath+'delete-payment/'+paymentId);
  }

  getPrev(filters: DateTableFilter, invoiceId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${invoiceId}/prev`, { params }) as Observable<number>;
  }

  getNext(filters: DateTableFilter, invoiceId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${invoiceId}/next`, { params }) as Observable<number>;
  }

  getPrevNext(filters: DateTableFilter, invoiceId: number): Observable<PrevNextModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${invoiceId}/prev-next`, { params }) as Observable<PrevNextModel>;
  }

  resendInvoice(invoiceId: number) {
    return this.http.post(this.apiPath + 'resend', invoiceId) as Observable<any>;
  }

  getFilterParams(filters: DateTableFilter): HttpParams {
    const str =  filters != null ? filters.str || '' : '';
    const dateFilterCols = filters != null ? filters.dateFilterCols || [] : [];
    const startFilterDate = filters != null ? filters.startFilterDate || null : null;
    const endFilterDate = filters != null ? filters.endFilterDate || null : null;
    const someAdditionalData = filters != null ? filters.someAdditionalData || null : null;

    let params = new HttpParams()


      .set('filterString', str)
      .set('startFilterDate', toISODateString(startFilterDate))
      .set('endFilterDate', toISODateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (filters != null && filters.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters != null && filters.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }

    if (filters != null && filters.enumFilter) {
      params = params.set('enumFilter', filters.enumFilter.value+'_'+filters.enumFilter.key);
    }


    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return params;
  }

  getAnnualFeeStats(filter: AnnualFeeStatsFilteringModel) {

    let params = new HttpParams()
      .set('startFilterDate', toServerDateString(filter.startFilterDate))
      .set('endFilterDate', toServerDateString(filter.endFilterDate))
      .set('companyId', filter.companyId != null ? filter.companyId.toString() : '');


    if (filter.productIds instanceof Array) {
      filter.productIds.forEach(element => {
        params = params.append('productIds', element);
      });
    }


    return this.http.get(this.apiPath+'annual-fee-stats', { params }) as Observable<AnnualFeeStatsModel>;
  }

  getInvoiceFileInline(invoiceId: number): Observable<HttpResponse<Blob>> {
    return this.http.get( this.apiPath + invoiceId + '/attachment-inline', { params: null, responseType: 'blob', observe: 'response' } );
  }

  generatePdf(invoiceId: number) : Observable<Upload> {
    return this.http.post(this.apiPath + 'generate-pdf', invoiceId) as Observable<Upload>;
  }

  setDunningStopDate(invoiceId: number, newDunningStopDate: Date) {
    return this.http.post(this.apiPath + 'dunning-stop-date', {
      id: invoiceId,
      date: getLocalISOString(newDunningStopDate),
    }) as Observable<Invoice>;
  }

}
